import {COLORS} from '@/utils/constants';
import {ISubmissionProps} from '../../resources/submission';
import {IConfigSchema,} from '../../resources/config-schema';
import {getIndicators} from './calculations';

interface IConfigSchemaProps {
    submissions: ISubmissionProps[]
}

export const configSchema = ({submissions}: IConfigSchemaProps): IConfigSchema => ({
    title: 'II. PARTECIPAZIONE ALLE ATTIVITA’ COLLETTIVE',
    tooltip: 'Il visual mostra il confronto tra il numero beneficiari che hanno partecipato alle attività collettive, aggiornato secondo le compilazioni della “Scheda rilevazione completamento profilo beneficiari”, e il valore che si prevede di raggiungere per la stessa variabile (70 anziani accompagnati) a conclusione del progetto.',
    type: 'column',
    categories: ['Numero di beneficiari che hanno partecipato alle attività collettive'],
    series: [
        {
            color: COLORS.blue,
            name: 'Valore Effetivo',
            data: [getIndicators(submissions)]
        },
        {
            color: COLORS.red,
            name: 'Valore Atteso',
            data: [70]
        },
    ],
});